import {
  Component,
  OnChanges,
  SimpleChanges,
  input,
  output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-date-picker',
  templateUrl: './date-picker.component.html',
  imports: [SHARED_IMPORTS],
})
export class DatePickerComponent implements OnChanges {
  readonly dateControl = new FormControl({ value: null, disabled: true });
  readonly minDate: Date = new Date();

  readonly enable = input<boolean>(undefined);
  readonly date = output<Date>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.enable.currentValue) {
      this.dateControl.enable();
    } else {
      this.dateControl.disable();
    }
  }

  submit() {
    if (!this.dateControl.errors) {
      this.date.emit(this.dateControl.value);
    }
  }
}
